module.exports = __webpack_public_path__ + "ae8fc48cf46b6d23ca82c6777661de70.svg";